const FOCUSABLE_SELECTOR = [
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  'a[href]',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export const focusNext = (fromEl) => {
  if (!fromEl) return false;
  const all = Array.from(document.querySelectorAll(FOCUSABLE_SELECTOR)).filter(el => {
    if (el.getAttribute('aria-hidden') === 'true') return false;
    if (el.offsetParent === null && el.getClientRects().length === 0) return false;
    return true;
  });
  const idx = all.indexOf(fromEl);
  if (idx === -1) return false;
  for (let i = idx + 1; i < all.length; i++) {
    if (all[i] && !all[i].disabled) {
      all[i].focus();
      if (all[i].select && all[i].tagName === 'INPUT') {
        try { all[i].select(); } catch {}
      }
      return true;
    }
  }
  return false;
};

export default focusNext;
